import React from "react";
import { SelectConvention, ButtonNewConvention } from "./components";
import './index.scss'

/**
 * @desc Convention form header.
 */
export const ConventionFormHeader = () => {
  return (
    <div className="convention-form-header">
      <SelectConvention />
      <ButtonNewConvention />
    </div>
  )
}